import React from 'react';

const EpisodeSkeleton = () => (
  <div className="w-full flex items-center gap-3 p-3 rounded-lg border border-brand-green/10 bg-white animate-pulse">
    <div className="w-12 h-12 flex-shrink-0 rounded bg-brand-green/10" />
    <div className="flex-1 min-w-0 space-y-2">
      <div className="h-3.5 bg-brand-green/10 rounded w-3/4" />
      <div className="h-2.5 bg-brand-green/10 rounded w-1/3" />
    </div>
  </div>
);

export default EpisodeSkeleton;